export enum Theme {
    DARK,
    LIGHT
}
